import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import S001 from "../pages/S001";
import S004 from "../pages/S004"; //S002 S004 S007 S010
import S005 from "../pages/S005"; //S005 S008
import S006 from "../pages/S006"; //S002 S006 S009
import {
  ROLE,
  URL_S001,
  URL_S002,
  URL_S003,
  URL_S004,
  URL_S005,
  URL_S006,
  URL_S007,
  URL_S008,
  URL_S009,
  URL_S010,
} from "../utils/constants";
import Welcome from "../pages/Welcome";
import ChangePassword from "../pages/ChangePassword";
import AuthorizedRoute from "./AuthorizedRoute";
import Report from "../pages/Report";
import WS_Summary from "../pages/ws_summary";

class Content extends Component {
  render() {
    return (
      <div className="content-wrapper">
        <Switch>
          <AuthorizedRoute
            exact
            requirements={[
              ROLE.user,
              ROLE.entry,
              ROLE.manager,
              ROLE.hr,
              ROLE.admin,
            ]}
            path={URL_S001}
            component={S001}
          ></AuthorizedRoute>
          <AuthorizedRoute
            requirements={[
              ROLE.user,
              ROLE.entry,
              ROLE.manager,
              ROLE.hr,
              ROLE.admin,
            ]}
            path={URL_S002 + "/:id"}
            component={S004}
          ></AuthorizedRoute>
          <AuthorizedRoute
            requirements={[ROLE.user, ROLE.entry, ROLE.admin]}
            path={URL_S003 + "/:id"}
            component={S006}
          ></AuthorizedRoute>
          <AuthorizedRoute
            requirements={[ROLE.user, ROLE.entry, ROLE.admin]}
            path={URL_S004 + "/:id"}
            component={S004}
          ></AuthorizedRoute>
          <AuthorizedRoute
            requirements={[ROLE.manager, ROLE.admin]}
            path={URL_S005}
            component={S005}
          ></AuthorizedRoute>
          <AuthorizedRoute
            requirements={[ROLE.manager, ROLE.admin]}
            path={URL_S006 + "/:id"}
            component={S006}
          ></AuthorizedRoute>
          <AuthorizedRoute
            requirements={[ROLE.manager, ROLE.admin]}
            path={URL_S007 + "/:id"}
            component={S004}
          ></AuthorizedRoute>
          <AuthorizedRoute
            requirements={[ROLE.hr, ROLE.admin]}
            path={URL_S008}
            component={S005}
          ></AuthorizedRoute>
          <AuthorizedRoute
            requirements={[ROLE.hr, ROLE.admin]}
            path={URL_S009 + "/:id"}
            component={S006}
          ></AuthorizedRoute>
          <AuthorizedRoute
            requirements={[ROLE.hr, ROLE.admin]}
            path={URL_S010 + "/:id"}
            component={S004}
          ></AuthorizedRoute>
          <Route path="/home/welcome" component={Welcome}></Route>
          <Route path="/home/changePassword" component={ChangePassword}></Route>
          <Route path="/home/report" component={Report}></Route>
          {/* <Route path="/home/ws_summary" component={WS_Summary}></Route> */}
        </Switch>
      </div>
    );
  }
}

export default Content;
